import { useLazyQuery as i } from "@apollo/client";
import { adeptusCampaignSchema as m } from "../../deserialize/yup/adeptusCampaign.js";
import { deserializeListData as p } from "../../graphql/deserialize/index.js";
import c from "../../graphql/query/getAdeptusCampaigns.js";
import { useState as u, useCallback as f } from "react";
const h = () => {
  const [t, { loading: e }] = i(c), [o, r] = u([]), s = f(async () => {
    const n = await t({
      variables: {
        targetTime: (/* @__PURE__ */ new Date()).toISOString()
      }
    }), a = p(
      n,
      m
    );
    return r(a), a;
  }, [t]);
  return {
    data: o,
    fetch: s,
    loading: e
  };
};
export {
  h as default
};
//# sourceMappingURL=useGetAdeptusCampaigns.js.map
